import {useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import wretch from 'wretch'

import { getCsrfToken } from '../utils/csrf'

const UserProfile = () => {
  const profile = useSelector((state) => state.auth.profile)
  const pending = useSelector( (state) => state.auth.pending)
  const [isCardVisible, setIsCardVisible] = useState(false)

  useEffect( () => {}, ['pending'])

  const toggleCardVisibility = () => setIsCardVisible(!isCardVisible)
  const logOut =  async (event) => {
    event.preventDefault()
    try {
      await wretch('/auth/sign_out')
        .headers({
          'X-CSRF-TOKEN': getCsrfToken()
        })
        .delete()
        .res( () => window.location.href = "/auth/sign_in" )
    }
    catch (error) { console.error('Erreur lors de la déconnexion:', error) }
    finally { window.location.href = "/" }
  }

  return (
    <div className="avatar avatar-placeholder static">
      <div className="bg-slate-400 text-black-content w-12 rounded-full" onClick={toggleCardVisibility} >
        { pending ? <span className="loading loading-ring loading-lg"></span> : <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg> 
        }
      </div>
      { isCardVisible && <div className="card text-gray-600 bg-base-100 border border-primary mx-auto w-[250px] p-4 mt-10 absolute right-6 top-[25px] z-100 hidden">
          { !profile ? <div className="text-center text-gray-500">Profil non disponible</div> :
            <div className="card-body">
              <h2 className="card-title">{profile.first_name} {profile.last_name}</h2>
              <p className="italic">({profile.email})</p>
              { profile.admin && (
                <div className='flex items-center justify-center'><a href="/admin" className='btn'>Interface Administrateur</a></div>
              )}
              <div className='flex items-center justify-center'><button id='logoutBtn' className='btn' onClick={logOut}>Se Déconnecter</button></div>
            </div>
          }
        </div>
      }
    </div>
  );
};

export default UserProfile;